export const TYPE = 'window_close_event';

export enum WindowCloseEventDataType {
	NAV_TOP = 'nav_top',
}

export interface WindowCloseEventData {
	window_id: string;
	type: WindowCloseEventDataType;
}